import axios from 'axios';
import { TEAMS_ALL } from '../constants/routes';
import { TeamOption, TeamsAllResponse } from '../types/auth/team';

const FEW_HITS_THRESHOLD = 8;

let cachedTeams: TeamOption[] | null = null;
let inFlight: Promise<TeamOption[]> | null = null;

function normalizeTeams(data: TeamsAllResponse | TeamOption[] | undefined): TeamOption[] {
  const raw = Array.isArray(data) ? data : data && Array.isArray(data.teams) ? data.teams : [];
  return raw.map((team) => ({
    id: team.id,
    name: team.name || (team as { team_name?: string }).team_name || '',
    team_enabled: team.team_enabled,
  }));
}

export function getCachedAllTeams(): TeamOption[] | null {
  return cachedTeams;
}

export function fetchAllTeams(): Promise<TeamOption[]> {
  if (cachedTeams) {
    return Promise.resolve(cachedTeams);
  }

  if (inFlight) {
    return inFlight;
  }

  inFlight = axios
    .get<TeamsAllResponse>(TEAMS_ALL)
    .then((response) => {
      const teams = normalizeTeams(response.data);
      cachedTeams = teams;
      return teams;
    })
    .finally(() => {
      inFlight = null;
    });

  return inFlight;
}

/** Case-insensitive startsWith; if too few hits, also includes. Preserves API order. */
export function filterTeamsByQuery(teams: TeamOption[], query: string): TeamOption[] {
  const q = query.trim().toLowerCase();
  if (!q) return [];

  const startsWithMatches: TeamOption[] = [];
  for (const team of teams) {
    if ((team.name || '').toLowerCase().startsWith(q)) {
      startsWithMatches.push(team);
    }
  }

  if (startsWithMatches.length >= FEW_HITS_THRESHOLD) {
    return startsWithMatches;
  }

  return teams.filter((team) => (team.name || '').toLowerCase().includes(q));
}
